import { useQuery } from '@tanstack/react-query';
import { serviceApiV3 } from '@/api/client';
import { mediaBase } from './configs';
import type { JobStats } from './vod-jobs-types';

// ============================================
// Query keys
// ============================================

export const vodStatsKeys = {
  jobs: (serviceId: string) =>
    ['vod', 'stats', 'jobs', serviceId] as const,
};

// ============================================
// Queries
// ============================================

/** Aggregate job counts by status — used by the Jobs Dashboard charts. */
export function useJobStats(serviceId: string) {
  return useQuery<JobStats>({
    queryKey: vodStatsKeys.jobs(serviceId),
    enabled: !!serviceId,
    queryFn: async () => {
      const res = await serviceApiV3.get(`${mediaBase(serviceId, 'vod')}/stats`);
      return res.data?.data ?? res.data;
    },
  });
}
